import { IState } from '@pvolve/sdk/src/redux/selectors';

export default {
    root: (state: IState) => state.orders,
    draftId: (state: IState) => state.orders.draftId,
};
